import { ENTRY_TYPES, TYPES_LIST_THAT_COMPARE_WITH_OTHER } from '../../../../../../../../constants';
import { sha256 } from 'js-sha256';

export const fieldError = (item) => {
  if (!item.title) {
    return true;
  }

  if (item.type === ENTRY_TYPES.FORMULA) {
    if (!item.unitName || !item.unitValue || !item.unitFieldName) {
      return true;
    }
    return false;
  }

  if (item.type === ENTRY_TYPES.DROPDOWN) {
    if (!item.values || !item.values.every((i) => i.value)) {
      return true;
    }
    return false;
  }

  if (item.type === ENTRY_TYPES.LIST) {
    return !item.listId;
  }
  if (item.type === ENTRY_TYPES.TEXT_BLOCK || item.type === ENTRY_TYPES.MULTIPLE_CHECKBOXES || item.type === ENTRY_TYPES.RADIO_BUTTON) {
    if (!item.mappedValues || !item.mappedValues.every((i) => i.value && i.key)) {
      return true;
    }
    return false;
  }

  if (item.type === ENTRY_TYPES.PDF_ATTACHMENT || item.type === ENTRY_TYPES.PICTURE_IN_TEMPLATE) {
    if (!item.file) {
      return true;
    }
    return false;
  }

  if (TYPES_LIST_THAT_COMPARE_WITH_OTHER.includes(item.type)) {
    if (item.comparisonsRules && item.comparisonsRules.fieldIdentity && !item.comparisonsRules.value) {
      return true;
    }
    return false;
  }

  return false;
};

export const generateFieldKey = (value) => {
  if (!value) {
    return null;
  }

  const isLatinCharacters = Boolean(
    value
      .replace(/ö/g, 'oe')
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/[^a-zA-Z0-9\s]+/gi, '')
  );

  if (isLatinCharacters) {
    const titleParts = value
      .replace(/ö/g, 'oe')
      .replace(/ä/g, 'ae')
      .replace(/ü/g, 'ue')
      .replace(/[^a-zA-Z0-9\s]+/gi, '')
      .split(' ')
      .filter((p) => p);

    const key = titleParts
      .map((text, index) => {
        if (index === 0) {
          return text.substring(0, 1).toLowerCase() + text.substring(1, text.length);
        } else {
          return text.substring(0, 1).toUpperCase() + text.substring(1, text.length);
        }
      })
      .join('');

    return key;
  } else {
    return sha256(value).slice(0, 30);
  }
};

export const beforeRouteLeaveFunction = (to, from, next, disablePrevent, $translate, changed, clear) => {
  if (disablePrevent) {
    return next();
  }

  const avoidMessageList = ['content-field-details', 'field-details', 'project-field-details'];
  if (avoidMessageList.includes(to.name) || !changed) {
    return next();
  }
  const answer = window.confirm($translate('You have not saved your progress Are you sure you want to leave this page'));
  if (answer) {
    if (clear) {
      clear();
    }
    next();
  } else {
    next(false);
  }
};
